import React from 'react';
import Utils from '../utils/utils';
import Price from './price';

const TransactionDetailHeader = ({total, transaction: t, transactionType}) => {
  const vat = Utils.vat(t.currency);

  const _transactionTotal = () => {
    let p = parseFloat(total || t.total);
    return Math.abs(p);
  }

  const _creditCard = () => {
    let cc = t.creditCardNumber;
    return cc && cc.substr(cc.length-8, 8);
  }

  let quantity = null, subTotal = null;
  if (t.bulk && transactionType === 'refund') {
    quantity = <span>{i18n.t('transactions.quantity')}: <span className='quantity'>{t.purchaseItems.reduce((a, b) => {return a + b.quantity}, 0)}</span></span>;
    if (!vat) {subTotal = <strong className="sub-total">{i18n.t('transactions.subtotal')}: <Price price={Utils.transactionSubtotal(t)} currency={t.currency} skipCurrency={true} /></strong>;}
  }

  const _renderSubTaxes = () => {
    if (t.currency === "AUD" || t.currency === "GBP") { return; }
    const taxRates = {};
    let subTaxes = t.purchaseItems.reduce((a,b,i) => {
      if (!b.taxes) {
        return a;
      }
      b.taxes.forEach(obj => {
        const { jurisdictionCode, tax, taxRate } = obj;
        if (jurisdictionCode) {
          let js = jurisdictionCode.slice(2);
          a[js] = (a[js] ? a[js] + parseFloat(tax) : parseFloat(tax));
          if (i === 0) {
            taxRates[js] = taxRates[js] ? taxRates[js] + parseFloat(taxRate) : parseFloat(taxRate);
          }
        }
      });
      return a;
    }, {});
    if (subTaxes.HST) {
      const HST = subTaxes.HST;
      delete subTaxes.HST;
      const GST = subTaxes.GST || 0;
      delete subTaxes.GST;

      subTaxes["GST/HST"] = GST + HST;
      taxRates["GST/HST"] = (taxRates.GST || 0) + taxRates.HST;
    }

    const keys = Object.keys(subTaxes).sort();
    if (keys.length) {
      return keys.map(key => {
        const tax = subTaxes[key];
        const s = Utils.transactionSubtotal(t);
        if (tax || key === "PST") {
          return <span key={key}>{i18n.t("transactions.portion", { subTax: key, rate: Utils.taxRate(taxRates[key]) })}: <Price price={tax} currency={t.currency} skipCurrency={true}/></span>;
        }
      });
    }
  }

  const _renderPrice = () => {
    if(vat){ return ''; }
    if (transactionType === 'refund') {
      const price = t.purchaseItems.map(i => parseFloat(i.itemPrice)).reduce((a, b) => a + b)
      return <span>{i18n.t('transactions.price')}: <Price price={price} currency={t.currency} skipCurrency={true}/></span>;
    } else {
      return <span>{i18n.t('transactions.subtotal')}: <Price price={Utils.transactionSubtotal(t)} currency={t.currency} skipCurrency={true}/></span>;
    }
  }

  const _renderTax = () => {
    const tax = parseFloat(t.total) -  t.purchaseItems.reduce((a,b) => {return a + (parseFloat(b.itemPrice) * b.quantity)}, 0);
    const subTaxes = _renderSubTaxes();
    if(vat) {
      if (subTaxes) {
        return subTaxes;
      }
      return (<span>{i18n.t('transactions.total-vat', { vat })}: <Price price={tax} currency={t.currency} skipCurrency={true}/></span>);
    }else{
      if (subTaxes) {
        return subTaxes;
      }
      return (<span>{i18n.t('transactions.tax')}: <Price price={tax} currency={t.currency} skipCurrency={true} /></span>);
    }
  }

  const _renderVATDisclosure = () => {
    if(!vat){ return ''; }
    return( <span className="vat-disclosure light">{i18n.t('transactions.vat-disclosure', { vat })}</span> );
  }

  const _sellerVat = () => {
    let sellerVat;
    switch (vat) {
      case "VAT":
        sellerVat = `${i18n.t('transactions.seller-vat')}: GB 792 2825 05`;
        break;
      case "GST":
        sellerVat = "Seller AU GST: ARN # 300009028961";
        break;
      default:
        sellerVat = '';
    }
    return sellerVat
  }

  const dateTitle = transactionType === 'refund' ? i18n.t('refunds.refunded') : i18n.t('transactions.purchased');
  const cardType = t.creditCardType && t.creditCardType.toUpperCase();
  return (
    <div className="clear header">
      <div className="left">
        <span>{dateTitle}: {Utils.toDateString(t.orderDate)}</span>
        <span>{i18n.t('transactions.confirmation#')}: {t.number}</span>
        <span>{i18n.t('transactions.payment')}: {cardType} {_creditCard()}</span>
        {vat && <span>{_sellerVat()}</span>}
      </div>
      <div className="right">
        {_renderPrice()}
        {quantity}
        {subTotal}
        { _renderTax() }
        <strong className="total">{i18n.t('transactions.total')}: <Price price={_transactionTotal()} currency={t.currency} /></strong>
        { _renderVATDisclosure() }
      </div>
    </div>
  );
}

export default TransactionDetailHeader;



/** WEBPACK FOOTER **
 ** ./src/js/components/transaction-detail-header.jsx
 **/